/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import {BaseComponent} from "@intuitionrobotics/thunderstorm/frontend";
import {DB_Alert} from "@app/app-shared/alert";
import * as emotion from "emotion";
import {COLORS} from "@res/colors";
import {FONTS} from "@res/fonts";
import {CommentsModule, OnCommentDeleted, OnCommentUpdated} from "@modules/CommentsModule";

type Props = {
    alert: DB_Alert<any>,
    onSubmit: (text: string) => void
    onCancel: () => void
    saveEnabled: boolean
}

type State = {
    currentComment: string
}

const commentInputStyle = emotion.css(
    {
        borderRadius: '6px',
        borderColor: COLORS.grays_2,
        width: '93%',
        resize: 'none',
        flex: 1,
        padding: 8,
        wordBreak: 'break-word',
        whiteSpace: 'initial',
        '::placeholder': {
            fontSize: 14,
            color: "#a4a6a8"
        }
    });

export class AddComment
    extends BaseComponent<Props, State>
    implements OnCommentUpdated, OnCommentDeleted {

    constructor(props: Props) {
        super(props);
        this.state = {
            currentComment: ''
        };
    }

    __onCommentUpdated(created: boolean, success: boolean, error?: string) {
        if (created && success)
            this.setState({currentComment: ''});
    }

    __onCommentDeleted() {
        this.setState({currentComment: ''});
    }

    renderTextArea = () => {
        return <textarea
            value={this.state.currentComment}
            placeholder={`Add a comment...`}
            onChange={event => {
                const comment = event.target.value;
                this.setState({currentComment: comment});
            }}
            className={commentInputStyle}
            name={'new_comment'}
        />;
    };

    saveButton = () => {
        const isAddingCommentToAlert = CommentsModule.isAddingCommentToAlert(this.props.alert._id);
        const enabled = isAddingCommentToAlert || !this.props.saveEnabled;
        return <div className={'flex_center clickable'}
                    onClick={() => {
                        if (enabled)
                            return;

                        this.props.onSubmit(this.state.currentComment);
                    }}
                    style={{
                        backgroundColor: !enabled ? COLORS.primary_blue : COLORS.neutral_gray_4,
                        cursor: !enabled ? "pointer" : "default",
                        minHeight: 30,
                        minWidth: 75,
                        borderRadius: 4,
                        textAlign: "center"
                    }}>
            {FONTS.reg_14('Save', {color: COLORS.white})}
        </div>;
    };


    cancelButton = () => {
        return <div style={{margin: '10px'}} onClick={() => {
            if (CommentsModule.isAddingCommentToAlert(this.props.alert._id))
                return;

            this.props.onCancel();
        }}>
            {
                FONTS.reg_16_secondary_dark("Cancel", {textDecoration: "underline", cursor: "pointer"})
            }
        </div>;
    };

    render() {
        return <div style={{margin: '20px'}}>
            {this.renderTextArea()}
            {this.state.currentComment.length > 1 && <div style={{display: 'flex', justifyContent: 'flex-end'}}>
                {this.cancelButton()}
                {this.saveButton()}
            </div>}
        </div>;
    }

}
